import { httpClient } from "../../../shared/api/httpClient"
import { ordenarPorNombre } from "../../../shared/utils/funciones"
import { conCacheSesion } from "../../../shared/api/cacheSesion"
import type {
    CompaniasYSucursalesResult,
    GruposPorUsuarioRequest,
    GruposUsuarioResult,
    ReiniciarContraseniaRequest,
    RutasDeAccesoRequest,
    RutasDeAccesoResult,
    TokenRequest,
    UsuarioAsignarGruposRequest,
    UsuarioBuscarRequest,
    UsuarioCrearResult,
    UsuarioIdRequest,
    UsuarioMostrarResult,
    UsuarioSimpleResult,
    UsuariosResult,
} from "../types/usuarios.types"

export const usuarioCrear = async (dataPOST: Record<string, unknown>): Promise<UsuarioCrearResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/Agregar", dataPOST)
        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                usuario: res.data.username,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                usuario: "",
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            usuario: "",
            message: "Error en el servidor",
        };
    }
}

export const usuariosBuscar = async (dataPOST: UsuarioBuscarRequest): Promise<UsuariosResult | undefined> => {
    try {
        const res = await httpClient.post("api/usuario/BuscarUsuario", dataPOST)
        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                usuarios: res.data.resultado,
                message: res.data.message,
            }
        }

    } catch (error) {
        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                usuarios: [],
                message: error.response.data.message,
            };
        }
        return {
            status: -1,
            usuarios: [],
            message: "Error en el servidor",
        }
    }
}

export const usuarioDelete = async (dataPOST: UsuarioIdRequest): Promise<UsuarioSimpleResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/EliminarUsuario", dataPOST)
        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }
    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}

export const usuarioMostrar = async (dataPOST: UsuarioIdRequest): Promise<UsuarioMostrarResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/MostrarUsuario", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                usuario: res.data.usuario,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                usuario: {},
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            usuario: {},
            message: "Error en el servidor",
        }
    }
}

export const usuarioEditar = async (dataPOST: Record<string, unknown>): Promise<UsuarioSimpleResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/ActualizarUsuario", dataPOST)
        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}

export const usuarioAsignarGrupos = async (dataPOST: UsuarioAsignarGruposRequest): Promise<UsuarioSimpleResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/AddUserGroup", dataPOST)
        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {

            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}

export const grupoMostrarGruposPorUsuario = async (dataPOST: GruposPorUsuarioRequest): Promise<GruposUsuarioResult | undefined> => {
    try {
        const res = await httpClient.post("api/usuario/MostrarUserGroup", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
                grupos: res.data.lista_grupo
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
                grupos: []
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
            grupos: []
        }
    }
}

export const usuarioListarTodosPorCompania = async (dataPOST: UsuarioBuscarRequest): Promise<UsuariosResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/ListarUsuario", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
                usuarios: res.data.lista
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
                usuarios: []
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
            usuarios: []
        }
    }
}

// Esta api funciona tanto para master y usuario normal.
// Los catálogos del usuario (companías/sucursales/sedes) son constantes durante la sesión y
// TODAS las páginas los piden al montar -> se cachean por token (dedup + evita re-consultar
// la misma API en cada navegación). Ver shared/api/cacheSesion.
export const usuarioObtenerCompaniasYSucursales = (dataPOST: TokenRequest): Promise<CompaniasYSucursalesResult | undefined> =>
    conCacheSesion(
        `xsede:${(dataPOST as any)?.token}`,
        async () => {
            try {
                const res = await httpClient.post("api/usuario/UsuarioXSede", dataPOST)
                //res.status 201
                if (res.data.status === 1) {
                    // Catálogos ordenados alfabéticamente para todos los selects (filtros y formularios).
                    return {
                        status: res.data.status,
                        message: res.data.message,
                        companias: ordenarPorNombre(res.data.compania),
                        sucursales: ordenarPorNombre(res.data.sucursales),
                        sedes: ordenarPorNombre(res.data.sedes)
                    }
                }
            } catch (error) {
                if (error.response && error.response.data.status === 0) {
                    return {
                        status: error.response.data.status,
                        message: error.response.data.message,
                        companias: [],
                        sucursales: [],
                        sedes: []
                    };
                }
                return {
                    status: -1,
                    message: "Error en el servidor",
                    companias: [],
                    sucursales: [],
                    sedes: []
                }
            }
        },
        (v) => (v as any)?.status === 1,
    )

export const usuarioObtenerRutasDeAcceso = async (dataPOST: RutasDeAccesoRequest): Promise<RutasDeAccesoResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/RutaPlana", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
                rutas : res.data.ruta_plana
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
                rutas : []
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
            rutas: []
        }
    }
}


export const usuarioCambiarContrasenia = async (dataPOST: Record<string, unknown>): Promise<UsuarioSimpleResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/ActualizarContrasenia", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}

export const usuarioReiniciarContraseña = async (dataPOST: ReiniciarContraseniaRequest): Promise<UsuarioSimpleResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/ReiniciarContrasenia", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}
export const mostrarFoto = async (dataPOST: Record<string, unknown>): Promise<UsuarioSimpleResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/MostrarFoto", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}
export const actualizarFoto = async (dataPOST: Record<string, unknown>): Promise<UsuarioSimpleResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/ReiniciarContrasenia", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}
